import React from 'react'
import Tooltip from '../tooltip/Tooltip'
import classnames from 'classnames'
class Handle extends React.Component {
	render() {
		const toggle =
			this.props.toggledSetting === 'both' ||
			this.props.toggledSetting === 'one'
				? 'none'
				: 'one'
		const expanded = this.props.toggledSetting === 'none' ? false : true
		const handleClass = classnames('viewer__handle', {
			'viewer__handle--active': this.props.toggledSetting !== 'none',
		})
		const tooltipText =
			this.props.toggledSetting === 'none' ? 'Show Pane' : 'Hide Pane'
		return (
			<div className={handleClass}>
				<Tooltip tooltipText={tooltipText} tooltiplLRPosition="right">
					<button
						aria-expanded={expanded}
						className={'viewer__handle__btn'}
						onClick={() => this.props.updateToggle(toggle)}
						type="button"
					>
						{/* <HandleIcon /> */}
						<span className="handle-icon"></span>
						<span className="visually-hidden">Toggle sidebar</span>
					</button>
				</Tooltip>
			</div>
		)
	}
}
export default Handle
